import { render, staticRenderFns } from "./journey-template-select-widget.vue?vue&type=template&id=0118b114&"
import script from "./journey-template-select-widget.vue?vue&type=script&lang=js&"
export * from "./journey-template-select-widget.vue?vue&type=script&lang=js&"
import style0 from "./journey-template-select-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports